















import { Vue, Component, Prop, InjectReactive } from "vue-property-decorator";
@Component({
  name: "MagicChildrenRowOps",
  components: {}
})
export default class MagicChildrenRowOps extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  private origin!: any;

  @Prop({
    type: Array,
    default: []
  })
  private widgets!: App.WebForm.Widget[];

  @Prop({
    type: String,
    default: ""
  })
  private loop!: string;

  @Prop({
    type: String,
    default: ""
  })
  private tableProperties!: any;

  @Prop({
    type: String,
    default: ""
  })
  private tableName!: any;

  @Prop({
    type: String,
    default: ""
  })
  private tableId!: any;

  @InjectReactive("htmlOptions")
  private params!: { options: App.WebForm.Config; model: any; isHtml: boolean };

  @Prop({
    type: Number
  })
  private row!: number;

  get widget(): App.WebForm.ChildrenTableWidget {
    const widget = this.params.options.widgets.find(
      (d) => d.property.propertyName === this.tableName
    );
    return (widget || { id: "-1" }) as App.WebForm.ChildrenTableWidget;
  }

  remove() {
    this.$delete(this.widget.widgetList, this.row);
  }

  add() {
    const cid: string = Math.random().toString().slice(-4);
    const widget = [
      ...this.widget.widgetList[0].map((i: any) => {
        const o = { ...i };

        o.id = o.id.replace(/:\w*/, `:${cid}`);
        return Object.assign({}, o, {
          value: "",
          text: "",
          ext: {},
          wid: o.wid,
          loop: cid
        });
      })
    ];

    this.widget.widgetList.splice(
      this.row + 1,
      0,
      JSON.parse(JSON.stringify(widget))
    );
  }
}
